import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/boris/app/gs/client-app/node_modules/.pnpm/next-intl@4.6.1_next@15.4.11_@babel+core@7.28.5_@playwright+test@1.59.1_react-dom@19.2._b32f418042dd1376d469e4444d9931b9/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/node_modules/.pnpm/next@15.4.11_@babel+core@7.28.5_@playwright+test@1.59.1_react-dom@19.2.3_react@19.2.3__react@19.2.3/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Aleksandar_Sretenovski.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Aleksandra.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Amir.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Ana_Marija.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Ana.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Andrej.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Angel.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Anne.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Bojana.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Boris.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/carousel/ImmoMates-Team-1.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/carousel/ImmoMates-Team-2.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/carousel/ImmoMates-Team-3.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/carousel/ImmoMates-Team-4.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/carousel/ImmoMates-Team-5.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/carousel/ImmoMates-Team-6.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/carousel/ImmoMates-Team-7.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/carousel/ImmoMates-Team-8.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Christopher.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Darijan.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Florian.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Goran.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Iskra.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Iva.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Ivan.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Ivana.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Jan_Weiler.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Jasna.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Karen.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Kim.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Klimentina.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Makedonka.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Marija_b_k.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Marija.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Monika.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Nikola.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Ratko.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Sara_Krstovska.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Simona.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Sofija_Bogoevska.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Sofija.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Soufiane.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Srna.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Stefan_Spirkovski.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Stefan_Trajkovski.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Stefan.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Stefanija.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Tamara.png");
;
import(/* webpackMode: "eager" */ "/home/boris/app/gs/client-app/public/images/team/Todorka.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/boris/app/gs/client-app/src/views/public/team/FounderMessage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/boris/app/gs/client-app/src/views/public/team/Head.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/boris/app/gs/client-app/src/views/public/team/TeamCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/boris/app/gs/client-app/src/views/public/team/TeamDescription.tsx");
